import axios from 'axios';
import API from '../config/API';

// Shared client ownership (BE salonClient/clientSharing.js): a salon's client
// can also belong to self-employed stylists (sharedWith). Booking one with a
// self-employed stylist shares them, per the salon setting or the booking's
// own choice; the salon can take a stylist off later.

function _headers() {
    return {
        'Content-Type': 'application/json',
        'accessToken': localStorage.getItem('accessToken') || '',
    };
}

function _data(res) {
    return (res && res.data && res.data.responseData) || {};
}

function _ok(res) {
    if (res && res.data && res.data.statusCode === 0) {
        const msg = (res.data.error && res.data.error.message) || res.data.message || 'Something went wrong';
        throw new Error(msg);
    }
    return _data(res);
}

/** { shareSEBookedClients, canChange } */
function getSetting() {
    return axios.get(API.SALON_CLIENT_SHARING_SETTING, { headers: _headers() }).then(_ok);
}

function setSetting(on) {
    return axios.put(API.SALON_CLIENT_SHARING_SETTING, { shareSEBookedClients: !!on }, { headers: _headers() }).then(_ok);
}

/** { ask, stylistName, defaultShare, alreadyShared } */
function sharePrompt(stylistId, clientId) {
    return axios.get(API.SALON_CLIENT_SHARE_PROMPT, { headers: _headers(), params: { stylistId, clientId } }).then(_ok);
}

/** { sharedWith: [{ userId, name }], canManage, isCoHolder } */
function sharingFor(clientUserId) {
    return axios.get(API.SALON_CLIENT_BASE + clientUserId + '/sharing', { headers: _headers() }).then(_ok);
}

/** { removed, sharedWith } */
function removeStylist(clientUserId, stylistUserId) {
    return axios.delete(API.SALON_CLIENT_BASE + clientUserId + '/sharing/' + stylistUserId, { headers: _headers() }).then(_ok);
}

export const clientSharingService = { getSetting, setSetting, sharePrompt, sharingFor, removeStylist };
